import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Amenities from "../../pages/Amenities";
import Highlights from "../../pages/Highlights";
import MobileCTA from "../../pages/MobileCTA";
import PropertyDetails from "../../pages/PropertyDetails";
import PropertyHero from "../../pages/PropertyHero";
import TrustSection from "../common/TrustSection";
import ChannelPartnerDisclosure from "../common/ChannelPartnerDisclosure";
import PageSeo from "../common/PageSeo";

const PropertyPage2 = () => {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  const getProperty = async () => {
    try {
      // ✅ CHANGED ENDPOINT
      const res = await fetch(`https://thakkar-backend.vercel.app/api/property/${id}`);

      if (!res.ok) {
        throw new Error("Property not found");
      }

      const data = await res.json();
      setProperty(data.data); // { success, data }
    } catch (err) {
      console.error("Failed to fetch property", err);
    } finally {
      setLoading(false);
    }
  };

  getProperty();
}, [id]);


  if (loading) {
    return <p className="text-center mt-20">Loading property...</p>;
  }

  if (!property) {
    return <p className="text-center mt-20">Property not found</p>;
  }

  return (
    <div className="bg-slate-50 min-h-screen mt-32">
      <PageSeo
        title={property.title || "Property Details"}
        description={
          property.description ||
          `${property.title} in ${property.location}. Explore verified details, pricing, amenities, and RERA project information.`
        }
      />

      {/* HERO */}
      <PropertyHero property={property} />

      {/* HIGHLIGHTS */}
      {property.highlights?.length > 0 && (
        <Highlights highlights={property.highlights} />
      )}

      {/* AMENITIES */}
      {property.amenities?.length > 0 && (
        <Amenities amenities={property.amenities} />
      )}

      {/* DETAILS */}
      <PropertyDetails property={property} />

      <section className="max-w-7xl mx-auto px-4 pb-4">
        <ChannelPartnerDisclosure developerName={property.developerName} />
      </section>

      <section className="max-w-7xl mx-auto px-4 pb-8">
        <TrustSection title="Trust and Compliance" />
      </section>

      {/* MOBILE CTA */}
      <MobileCTA
        price={property.startingPrice || property.price1}
        phone={property.phone}
        whatsapp={property.whatsapp}
        title={property.title}
      />
    </div>
  );
};

export default PropertyPage2;
